import React from 'react';

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-bold mb-8 text-center">Terms and Conditions</h1>
      <p className="text-gray-600 text-center mb-12">Last updated: January 1, 2024</p>
      
      <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
        <section>
          <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700">
            By accessing and using Janvahan's website, mobile application, and services, you agree to be bound 
            by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">2. Booking and Payment</h2>
          <p className="text-gray-700 mb-4">
            When you book a vehicle through our platform:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>Booking amount is non-refundable unless specified otherwise</li>
            <li>Full payment must be completed before vehicle delivery</li>
            <li>Prices are subject to change without prior notice</li>
            <li>All prices are in Indian Rupees (INR) and inclusive of applicable taxes</li>
            <li>We reserve the right to cancel any booking at our discretion</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">3. Test Ride Policy</h2>
          <p className="text-gray-700 mb-4">
            Test rides are subject to availability and prior scheduling. By booking a test ride:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>You must provide valid identification at the time of test ride</li>
            <li>You must hold a valid driving license</li>
            <li>You agree to follow all safety instructions provided by our staff</li>
            <li>We reserve the right to refuse test ride to anyone without providing reason</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">4. Vehicle Ownership and Warranty</h2>
          <p className="text-gray-700 mb-4">
            Upon full payment and delivery:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>Ownership transfers to you after complete payment</li>
            <li>Warranty terms are as specified in the warranty document</li>
            <li>Unauthorized modifications void the warranty</li>
            <li>Regular maintenance as per schedule is mandatory</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">5. User Account</h2>
          <p className="text-gray-700 mb-4">
            To use certain features, you may need to create an account. You are responsible for:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Providing accurate and current information</li>
            <li>Notifying us immediately of any unauthorized use</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">6. Intellectual Property</h2>
          <p className="text-gray-700">
            All content on our website and app, including text, graphics, logos, images, and software, 
            is the property of Janvahan and protected by intellectual property laws. You may not reproduce, 
            distribute, or create derivative works without our express written consent.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">7. Limitation of Liability</h2>
          <p className="text-gray-700">
            To the maximum extent permitted by law, Janvahan shall not be liable for any indirect, incidental, 
            special, consequential, or punitive damages arising out of or relating to your use of our services. 
            Our total liability shall not exceed the amount paid by you for the specific vehicle giving rise to the claim.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">8. Cancellation and Refund</h2>
          <p className="text-gray-700 mb-4">
            Cancellation policies:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>Booking cancellation within 24 hours: Full refund of booking amount</li>
            <li>Booking cancellation after 24 hours: Booking amount non-refundable</li>
            <li>Vehicle cancellation after delivery: Subject to company policy</li>
            <li>Refunds will be processed within 7-10 business days</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">9. Governing Law</h2>
          <p className="text-gray-700">
            These terms shall be governed by and construed in accordance with the laws of India. 
            Any disputes arising under these terms shall be subject to the exclusive jurisdiction 
            of the courts in Bangalore, Karnataka.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">10. Modifications to Terms</h2>
          <p className="text-gray-700">
            We reserve the right to modify these terms at any time. Changes will be effective immediately 
            upon posting on our website. Your continued use of our services constitutes acceptance of the modified terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">11. Contact Information</h2>
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-gray-700">For questions about these Terms and Conditions, please contact:</p>
            <p className="text-gray-700 mt-2">Email: legal@janvahan.com</p>
            <p className="text-gray-700">Phone: +91 80 1234 5678</p>
            <p className="text-gray-700">Address: Janvahan Towers, Electronic City, Bangalore - 560100</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Terms;